/**
 * Country and state/province reference data.
 * Used by Google Places Autocomplete, state dropdowns, and address forms.
 */

export const COUNTRIES = [
  { code: 'AU', name: 'Australia', flag: '🇦🇺', phoneCode: '+61', postalLabel: 'Postcode', stateLabel: 'State' },
  { code: 'US', name: 'United States', flag: '🇺🇸', phoneCode: '+1', postalLabel: 'ZIP Code', stateLabel: 'State' },
  { code: 'GB', name: 'United Kingdom', flag: '🇬🇧', phoneCode: '+44', postalLabel: 'Postcode', stateLabel: 'County' },
  { code: 'NZ', name: 'New Zealand', flag: '🇳🇿', phoneCode: '+64', postalLabel: 'Postcode', stateLabel: 'Region' },
  { code: 'CA', name: 'Canada', flag: '🇨🇦', phoneCode: '+1', postalLabel: 'Postal Code', stateLabel: 'Province' },
  { code: 'IE', name: 'Ireland', flag: '🇮🇪', phoneCode: '+353', postalLabel: 'Eircode', stateLabel: 'County' },
  { code: 'SG', name: 'Singapore', flag: '🇸🇬', phoneCode: '+65', postalLabel: 'Postal Code', stateLabel: 'District' },
  { code: 'AE', name: 'United Arab Emirates', flag: '🇦🇪', phoneCode: '+971', postalLabel: 'PO Box', stateLabel: 'Emirate' },
];

export const STATES_BY_COUNTRY = {
  AU: [
    { code: 'NSW', name: 'New South Wales' },
    { code: 'VIC', name: 'Victoria' },
    { code: 'QLD', name: 'Queensland' },
    { code: 'SA', name: 'South Australia' },
    { code: 'WA', name: 'Western Australia' },
    { code: 'TAS', name: 'Tasmania' },
    { code: 'NT', name: 'Northern Territory' },
    { code: 'ACT', name: 'Australian Capital Territory' },
  ],
  US: [
    { code: 'AL', name: 'Alabama' }, { code: 'AK', name: 'Alaska' }, { code: 'AZ', name: 'Arizona' },
    { code: 'AR', name: 'Arkansas' }, { code: 'CA', name: 'California' }, { code: 'CO', name: 'Colorado' },
    { code: 'CT', name: 'Connecticut' }, { code: 'DE', name: 'Delaware' }, { code: 'FL', name: 'Florida' },
    { code: 'GA', name: 'Georgia' }, { code: 'HI', name: 'Hawaii' }, { code: 'ID', name: 'Idaho' },
    { code: 'IL', name: 'Illinois' }, { code: 'IN', name: 'Indiana' }, { code: 'IA', name: 'Iowa' },
    { code: 'KS', name: 'Kansas' }, { code: 'KY', name: 'Kentucky' }, { code: 'LA', name: 'Louisiana' },
    { code: 'ME', name: 'Maine' }, { code: 'MD', name: 'Maryland' }, { code: 'MA', name: 'Massachusetts' },
    { code: 'MI', name: 'Michigan' }, { code: 'MN', name: 'Minnesota' }, { code: 'MS', name: 'Mississippi' },
    { code: 'MO', name: 'Missouri' }, { code: 'MT', name: 'Montana' }, { code: 'NE', name: 'Nebraska' },
    { code: 'NV', name: 'Nevada' }, { code: 'NH', name: 'New Hampshire' }, { code: 'NJ', name: 'New Jersey' },
    { code: 'NM', name: 'New Mexico' }, { code: 'NY', name: 'New York' }, { code: 'NC', name: 'North Carolina' },
    { code: 'ND', name: 'North Dakota' }, { code: 'OH', name: 'Ohio' }, { code: 'OK', name: 'Oklahoma' },
    { code: 'OR', name: 'Oregon' }, { code: 'PA', name: 'Pennsylvania' }, { code: 'RI', name: 'Rhode Island' },
    { code: 'SC', name: 'South Carolina' }, { code: 'SD', name: 'South Dakota' }, { code: 'TN', name: 'Tennessee' },
    { code: 'TX', name: 'Texas' }, { code: 'UT', name: 'Utah' }, { code: 'VT', name: 'Vermont' },
    { code: 'VA', name: 'Virginia' }, { code: 'WA', name: 'Washington' }, { code: 'WV', name: 'West Virginia' },
    { code: 'WI', name: 'Wisconsin' }, { code: 'WY', name: 'Wyoming' }, { code: 'DC', name: 'District of Columbia' },
  ],
  GB: [
    { code: 'ENG', name: 'England' }, { code: 'SCT', name: 'Scotland' },
    { code: 'WLS', name: 'Wales' }, { code: 'NIR', name: 'Northern Ireland' },
  ],
  NZ: [
    { code: 'AUK', name: 'Auckland' }, { code: 'WGN', name: 'Wellington' },
    { code: 'CAN', name: 'Canterbury' }, { code: 'WKO', name: 'Waikato' },
    { code: 'BOP', name: 'Bay of Plenty' }, { code: 'OTA', name: 'Otago' },
    { code: 'MWT', name: 'Manawatu-Wanganui' }, { code: 'HKB', name: "Hawke's Bay" },
    { code: 'TKI', name: 'Taranaki' }, { code: 'NTL', name: 'Northland' },
    { code: 'STL', name: 'Southland' }, { code: 'GIS', name: 'Gisborne' },
    { code: 'MBH', name: 'Marlborough' }, { code: 'NSN', name: 'Nelson' },
    { code: 'TAS', name: 'Tasman' }, { code: 'WTC', name: 'West Coast' },
  ],
  CA: [
    { code: 'AB', name: 'Alberta' }, { code: 'BC', name: 'British Columbia' },
    { code: 'MB', name: 'Manitoba' }, { code: 'NB', name: 'New Brunswick' },
    { code: 'NL', name: 'Newfoundland and Labrador' }, { code: 'NS', name: 'Nova Scotia' },
    { code: 'ON', name: 'Ontario' }, { code: 'PE', name: 'Prince Edward Island' },
    { code: 'QC', name: 'Quebec' }, { code: 'SK', name: 'Saskatchewan' },
    { code: 'NT', name: 'Northwest Territories' }, { code: 'NU', name: 'Nunavut' },
    { code: 'YT', name: 'Yukon' },
  ],
  IE: [],
  SG: [],
  AE: [
    { code: 'AZ', name: 'Abu Dhabi' }, { code: 'DU', name: 'Dubai' },
    { code: 'SH', name: 'Sharjah' }, { code: 'AJ', name: 'Ajman' },
    { code: 'UQ', name: 'Umm Al Quwain' }, { code: 'RK', name: 'Ras Al Khaimah' },
    { code: 'FU', name: 'Fujairah' },
  ],
};

// Google Places uses long_name for states - build reverse lookup per country
export const STATE_NAME_TO_CODE = {};
Object.entries(STATES_BY_COUNTRY).forEach(([countryCode, states]) => {
  STATE_NAME_TO_CODE[countryCode] = {};
  states.forEach(s => {
    STATE_NAME_TO_CODE[countryCode][s.name] = s.code;
  });
});

/**
 * Get states/provinces for a country code.
 * Falls back to empty array if unknown country.
 */
export const getStatesForCountry = (countryCode) => {
  return STATES_BY_COUNTRY[countryCode] || [];
};

/**
 * Get country metadata by code.
 */
export const getCountryByCode = (code) => {
  return COUNTRIES.find(c => c.code === code);
};

/**
 * Resolve a Google Places state long_name to its abbreviation for a given country.
 * Falls back to the short_name from Google if no mapping found.
 */
export const resolveStateCode = (countryCode, longName, shortName) => {
  const mapping = STATE_NAME_TO_CODE[countryCode];
  if (mapping && mapping[longName]) return mapping[longName];
  return shortName || longName;
};
